export enum StrainReportType {
    Docx = 0,
    Pdf = 1
}
